import { MouseEventHandler } from "react";
import { Button, Icon, Box } from "@bca/ui-library";
import css from "@styled-system/css";

import styled from "styled-components";

import media from "../media";

const StyledBox = styled(Box)`
  display: none;
  ${media.tablet} {
    display: block;
    z-index: 1;
  }
`;

const TrackButtonTablet: React.FunctionComponent<{
  isTracked: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ isTracked, onClick }) => {
  return (
    <StyledBox mr={5} data-testid="tablet-track-container">
      <Button
        variant="tertiary"
        padding="0px"
        height="auto"
        width="auto"
        onClick={onClick}
        css={`
          ${css({
            borderColor: isTracked ? "secondary-orange" : "primary-white",
          })}
        `}
        title={isTracked ? "Remove Tracking" : "Track"}
      >
        <Icon
          width="21px"
          height="21px"
          name="star"
          weight={isTracked ? "solid" : "regular"}
          color={isTracked ? "secondary-orange" : "footer-blue"}
        ></Icon>
      </Button>
    </StyledBox>
  );
};

export default TrackButtonTablet;
